import { render, staticRenderFns } from "./ActionTable.vue?vue&type=template&id=3f4f629f&scoped=true&"
import script from "./ActionTable.vue?vue&type=script&lang=js&"
export * from "./ActionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4f629f",
  null
  
)

export default component.exports